import React from 'react';
import { Accordion } from './Accordion';
const faqs = [{
  question: '¿El pago es único?',
  answer: 'Sí, el pago es único. No hay suscripciones ni pagos recurrentes. Pagás una sola vez y accedés al material completo de forma permanente.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Es muy simple: ingresás tu correo electrónico, realizás el pago, y el contenido completo te llega automáticamente a ese correo. IMPORTANTE: Revisá la carpeta de spam o correo no deseado por las dudas. Si tenés cualquier inconveniente, podés comunicarte a sectordigital53@gmail.com y te ayudamos de inmediato.'
}, {
  question: '¿Reemplaza una formación o supervisión profesional?',
  answer: 'No. Este kit es un material de apoyo clínico diseñado para profesionales de la salud mental que ya cuentan con formación de base. No reemplaza formación académica, supervisión clínica, ni evaluación psicológica formal. Es una herramienta complementaria para organizar y estructurar tu práctica con este perfil específico.'
}, {
  question: '¿Es un curso con clases en vivo?',
  answer: 'No, no es un curso. Es un kit digital clínico-práctico que incluye módulos, guías, plantillas, herramientas y bonus en formato descargable. Todo el material está disponible de forma inmediata para que lo uses a tu propio ritmo.'
}, {
  question: '¿Puedo usarlo con pacientes adultos?',
  answer: 'Sí, absolutamente. El enfoque del kit contempla niños, adolescentes y adultos. Muchas de las herramientas son especialmente útiles para adolescentes y adultos con alta intensidad cognitiva, emocional o identitaria.'
}];
export function FAQ() {
  return <div className="py-16 bg-white" data-id="element-21">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22">
        <h2 className="text-3xl font-bold text-center text-slate-900 mb-12" data-id="element-23">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-4" data-id="element-24">
          {faqs.map((faq, i) => <Accordion key={i} title={faq.question} data-id="element-25">
              <p className="text-slate-600 leading-relaxed" data-id="element-26">{faq.answer}</p>
            </Accordion>)}
        </div>
      </div>
    </div>;
}